export function translateColumn (column: string) {
    switch (column) {
        case "adrenlineSyringesUsed":
            return "Adrenline Syringes Used"
        case "airDropItemsLooted":
            return "Air Drop Items Looted"
        case "armKills":
            return "Arm Kills"
        case "assists":
            return "Assists"
        case "bandagesUsed":
            return "Bandages Used"
        case "boosts":
            return "Total Boosts"
        case "bulletsFired":
            return "Bullets Fired (Rounded)"
        case "c4Kills":
            return "C4 Kills"
        case "DBNOs":
            return "Knocks"
        case "doorsUsed":
            return "Doors Used"
        case "emergencyPickupsUsed":
            return "Emergency Pickups Used"
        case "energyDrinksUsed":
            return "Energy Drinks Used"
        case "fencesDestroyed":
            return "Fences Broken"
        case "firstAidsUsed":
            return "First Aids Used"
        case "flashbangsThrown":
            return "Stuns"
        case "fuelPuddlesIgnited":
            return "Gas Can Trails Ignited"
        case "gasCansUsed":
            return "Gas Poured"
        case "headshotKills":
            return "Headshot Kills"
        case "heals":
            return "Heals"
        case "healthHealed":
            return "Health Healed"
        case "itemsDropped":
            return "Items Dropped"
        case "itemsLooted":
            return "Items Looted"
        case "kills":
            return "Kills"
        case "legKills":
            return "Leg Kills"
        case "medKitsUsed":
            return "Med Kits Used"
        case "molotovKills":
            return "Molotov Kills"
        case "molotovsThrown":
            return "Mollies Thrown"
        case "nadeKills":
            return "Nade Kills"
        case "nadesThrown":
            return "Nades Thrown"
        case "painkillersUsed":
            return "Pain Killers Used"
        case "parachuteDistance":
            return "Parachute Distance"
        case "pelvisKills":
            return "Pelvis Kills"
        case "playerItemsLooted":
            return "Items Looted From Players"
        case "revives":
            return "Revives"
        case "rideDistance":
            return "Drive Distance"
        case "smokesThrown":
            return "Smokes"
        case "suicides":
            return "Suicides"
        case "swimDistance":
            return "Swim Distance"
        case "throwablesThrown":
            return "Throwables Thrown"
        case "tiresPopped":
            return "Tires Popped"
        case "torsoKills":
            return "Torso Kills"
        case "walkDistance":
            return "Distance Walked"
        case "wallbangKills":
            return "Wallbang Kills"
        case "vaults":
            return "Vaults"
        case "vehicleDamage":
            return "Vehicle Damage"
        case "vestsDestroyed":
            return "Vests Destroyed"
        case "windowsDestroyed":
            return "Windows Broken"
        case "carryTime":
            return "Time Spent Carrying (s)"
        case "carriedTime":
            return "Time Spent being Carried (s)"
        case "carryTimeTeammate":
            return "Time Spent Carrying a Teammate (s)"
        case "carriedTimeTeammate":
            return "Time Spent Carried by a Teammate (s)"
        case "carryTimeEnemy":
            return "Time Spent Carrying an Enemy (s)"
        case "carriedTimeEnemy":        
            return "Time Spent Carried by an Enemy (s)"
        case "birdsFreed":
            return "Birds Freed"
        case "fireworksUsed":
            return "Fireworks Used"
        case "stunsUsed":
            return "Stun Gun Used"
        case "bambooDestroyed":
            return "Bamboo Destroyed"
        case "goldSold":
            return "Gold Sold"
        case "evChargerDestroyed":
            return "EV Chargers Destroyed"
        case "jukeboxUsed":
            return "JukeBoxes Used"
        case "safeOpened":
            return "Safes Opened"
        case "c4sThrown":
            return "C4s Thrown"
        case "eCoversThrown":
            return "Emergency Covers Thrown"
        default:
            return "Column not found"
    }
}
